import {
    Context,
    createContext,
    Dispatch,
    FunctionComponent,
    useContext,
    useState,
} from 'react';

type ConfigurationPanelState = {
    // panel visible
    isActive: boolean;
    setIsActive: Dispatch<boolean>;

    // panel collapsed
    isCollapsed: boolean;
    setIsCollapsed: Dispatch<boolean>;
};

const initialState: ConfigurationPanelState = {
    isActive: false,
    setIsActive: () => false,

    isCollapsed: false,
    setIsCollapsed: () => false,
};

const ConfigurationPanelContext: Context<ConfigurationPanelState> =
    createContext(initialState);

export const ConfigurationPanelContextProvider: FunctionComponent<
    React.PropsWithChildren<unknown>
> = ({ children }) => {
    const [isActive, setIsActive] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(false);

    return (
        <ConfigurationPanelContext.Provider
            value={{
                isActive,
                setIsActive,
                isCollapsed,
                setIsCollapsed,
            }}
        >
            {children}
        </ConfigurationPanelContext.Provider>
    );
};

export const useConfigurationPanelContext = () => {
    return useContext(ConfigurationPanelContext);
};
